import {
  changePage,
  fetchLenderAccounts,
  fetchTransactionHistory,
  updateFilters
} from './historyActions';
import { createReducer } from 'actionware';
import { createState } from 'stateware';

const initialState = createState({
  accounts: [],
  historyRows: [],
  currentFilters: {},
  currentPage: 1,
  currentLimit: 0,
  total: 100
});

export default createReducer(initialState)
  .on(fetchLenderAccounts, (state, accounts) =>
    initialState.copy({
      accounts
    })
  )
  .on(
    fetchTransactionHistory,
    (state, { currentPage, currentLimit, total, data }) => {
      return state.copy({
        currentPage,
        currentLimit,
        total,
        historyRows: data
      });
    }
  )
  .on(updateFilters, (state, { type, value }) =>
    state.copy({
      currentFilters: {
        ...state.currentFilters,
        [type]: value
      }
    })
  )
  .on(changePage, (state, { currentPage }) =>
    state.copy({
      currentPage
    })
  );
